module.exports = __webpack_public_path__ + "assets/img/59@3x.bbfc66f0.png";